import React from 'react'
import './gallery.css';



function Gallery() {
  return (
    <div>Gallery</div>
  )
}

export default Gallery